/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { selectOrder } from '@/domains/esim/order/selectors';
import { actions as orderActions } from '@/domains/esim/order';
import { useWindowSize } from '@/hooks/index';
import {
  hooks as stockHooks,
  actions as stockActions,
  selectors as stockSelectors,
} from '@/domains/esim/stock';
import { SectionTitle, TextBlock, Loader } from '@/ui/index';
import CreateOwnPhoneInput from '@/ui/CreateOwnPhoneInput/CreateOwnPhoneInput';

import styles from './FindYourEsimFlow.module.scss';

const FindYourEsimFlow = ({ data, blockRef, detail }) => {
  const router = useRouter();
  const [prefixes, setPrefixes] = useState([]);
  useEffect(() => {
    setSortValue({
      name: detail?.all_option_text,
      id: '0',
    });
    setPrefixes([
      {
        name: detail?.all_option_text,
        id: '0',
      },
      {
        name: '055',
        id: '1',
      },
      {
        name: '099',
        id: '2',
      },
    ]);
  }, [router?.locale, detail?.all_option_text]);
  const { page } = useSelector(stockSelectors.selectStock);
  const { customerPrefix, customerNumber } = useSelector(selectOrder);
  const [sortValue, setSortValue] = React.useState(prefixes[0]);
  const [reset, setReset] = React.useState(false);
  const [tabs] = React.useState(data?.tabs);
  const [value, setValue] = React.useState(['', '', '', '', '', '', '']);

  const dispatch = useDispatch();
  const [allStock, setAllStock] = useState([]);
  const [windowsX] = useWindowSize();

  const resetFields = () => {
    setAllStock([]);
    setValue(['', '', '', '', '', '', '']);
    setSortValue({
      name: detail?.all_option_text,
      id: '0',
    });
    dispatch(stockActions.setPage(0));
    dispatch(orderActions.setCustomerNumber('*******'));
    setReset(true);
  };
  const {
    data: stockData,
    isLoading,
    status,
  } = stockHooks.useGetStock({
    page,
    number: reset ? null : customerNumber,
    prefix: reset ? null : customerPrefix,
    size: windowsX > 600 ? 10 : 6,
  });

  useLayoutEffect(() => {
    setAllStock([]);
  }, []);
  const searchEsim = () => {
    // it vill be chaged in future
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search',
    });
    dispatch(stockActions.setPage(0));
    setAllStock([]);
    setReset(false);
  };

  useEffect(() => {
    if (stockData?.data?.length > 0) {
      const updatedStock = stockData.data.map((item) => {
        const msisdnStr = String(item?.msisdn || '').trim();
        return {
          ...item,
          price: msisdnStr?.startsWith('1')
            ? Number(item?.price) + 4
            : item?.price,
        };
      });

      setAllStock((prevStock) => {
        if (page === 0) {
          return updatedStock;
        }
        const existingMsisdnId = new Set(prevStock?.map((item) => item?.id));
        const newUniqueStock = updatedStock?.filter(
          (item) => !existingMsisdnId.has(item?.id),
        );
        return [...prevStock, ...newUniqueStock];
      });
    }
  }, [page, stockData]);

  const onReset = () => {
    router.push('/');
  };

  const getPrefix = (e) => {
    setSortValue(e);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'search',
    });
    dispatch(
      orderActions.setCustomerPrefix(
        e?.name === prefixes[0]?.name ? '' : e?.name?.slice(-2),
      ),
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      className={'wrapper section'}
      ref={blockRef}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.intro}>
        <SectionTitle className={styles.title} titleModify={'title--large'}>
          {detail?.title}
        </SectionTitle>
        <TextBlock className={classNames(['text--large', styles.description])}>
          {detail?.description}
        </TextBlock>
      </div>
      {stockData && (
        <CreateOwnPhoneInput
          tabs={tabs}
          sortValue={sortValue}
          detail={detail}
          setSortValue={setSortValue}
          onChange={(val) => {
            setValue(val);
            dispatch(
              orderActions.setCustomerNumber(
                Array.from(val, (item) => item || '*')?.join(''),
              ),
            );
          }}
          resetFields={resetFields}
          value={value}
          onSubmit={searchEsim}
          onReset={onReset}
          sortData={prefixes}
          data={allStock}
          loadMore={() => dispatch(stockActions.setPage(page + 1))}
          onSelect={getPrefix}
          isLoading={status}
          totalPage={stockData?.metadata?.pagination?.total_page}
        />
      )}
    </div>
  );
};

export default FindYourEsimFlow;
